import "./errorpage.css";
import { Link } from "react-router-dom";

export const ErrorPage = () => {
  return (
    <section className="error-page">
      <div className="center">
        <div className="error__box">
          <h2>Survival Interactive couldn't locate the Page</h2>
          <p>Refresh or Return to homepage.</p>
        </div>
        <Link to="/" className="btn primary">
          Back to the Homepage
        </Link>
      </div>
    </section>
  );
};
